import { computed, ref } from "vue"

interface Company {
  id: string
  name: string
}

// Global reactive state
const selectedCompanyId = ref<string | null>(null)
const availableCompanies = ref<Company[]>([])

export const useCompanyState = () => {
  const selectedCompany = computed(() => {
    if (!selectedCompanyId.value) return null
    return (
      availableCompanies.value.find(
        (company) => company.id === selectedCompanyId.value,
      ) || null
    )
  })

  const setSelectedCompany = (companyId: string | null) => {
    selectedCompanyId.value = companyId
  }

  const setAvailableCompanies = (companies: Company[]) => {
    availableCompanies.value = companies
  }

  return {
    selectedCompany,
    selectedCompanyId: computed(() => selectedCompanyId.value),
    availableCompanies: computed(() => availableCompanies.value),
    setSelectedCompany,
    setAvailableCompanies,
  }
}
